var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { ref: "container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("selectEnvironment")
                  },
                  on: { change: _vm.Renewal },
                  model: {
                    value: _vm.searchData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "is_prod", $$v)
                    },
                    expression: "searchData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                height: "32px"
              },
              attrs: { span: 10 }
            },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.typeChange },
                  model: {
                    value: _vm.radio,
                    callback: function($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("roleIdQuery")))
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("roleNameQuery")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              dataOptions: "pickerOptionsOnMonth",
              propsData: {
                isProduct: false,
                adChannel: false,
                adPlacement: false,
                isPayChannel: false,
                isCountry: false,
                isDate: false,
                isCurrency: true
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: _vm.$t("pleaseSelectServer")
                  },
                  model: {
                    value: _vm.searchData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "server_id", $$v)
                    },
                    expression: "searchData.server_id"
                  }
                },
                _vm._l(_vm.serverLists, function(item) {
                  return _c("el-option", {
                    key: item.serverID,
                    attrs: { label: item.serverName, value: item.serverID }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.radio == 1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("roleName")
                    },
                    model: {
                      value: _vm.searchData.role_name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "role_name", $$v)
                      },
                      expression: "searchData.role_name"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.radio == 2
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("userId")
                    },
                    model: {
                      value: _vm.searchData.user_id,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "user_id", $$v)
                      },
                      expression: "searchData.user_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.radio == 2
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("roleIdWithComma")
                    },
                    model: {
                      value: _vm.searchData.role_id,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "role_id", $$v)
                      },
                      expression: "searchData.role_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.radio == 2
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("sdkPlayerId")
                    },
                    model: {
                      value: _vm.searchData.sdk_user_id,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "sdk_user_id", $$v)
                      },
                      expression: "searchData.sdk_user_id"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isderive && _vm.searchList.length
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.exuserInfoAll }
                    },
                    [_vm._v(_vm._s(_vm.$t("export")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoadingOne },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1, true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("query")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addExport.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchExport")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoadingOne,
              expression: "reqLoadingOne"
            }
          ],
          staticClass: "marginB",
          attrs: { data: _vm.searchList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "server_name",
              label: _vm.$t("server"),
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_name",
              label: _vm.$t("roleName"),
              width: "200"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "user_id", label: _vm.$t("userId"), width: "200" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "sdk_user_id",
              label: _vm.$t("sdkPlayerId"),
              width: "200"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_id", label: _vm.$t("roleId"), width: "200" }
          }),
          _c("el-table-column", {
            attrs: { prop: "level", label: _vm.$t("level"), width: "150" }
          }),
          _c("el-table-column", {
            attrs: { prop: "vip", label: _vm.$t("vipLevel"), width: "150" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "recharge_amount",
              label: _vm.$t("rechargeTotalAmount"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "recharge_amount",
              label: _vm.$t("giftCodeActivation"),
              "min-width": "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.gift_code_use.length == 0
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("no")))])
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#409EFF",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$refs.watchCodeDetails.init(row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("view")))]
                        )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "real_time_amount",
              label: _vm.$t("realTimeRechargeAmount"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "fighting",
              label: _vm.$t("fightingPower"),
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "account_type",
              label: _vm.$t("thirdPartyLoginType"),
              width: "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "register_country",
              label: _vm.$t("registerCity"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_login_country",
              label: _vm.$t("lastLoginCity"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "relevancy_role_name",
              label: _vm.$t("associatedAccount"),
              "show-overflow-tooltip": "",
              width: "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { cursor: "pointer" }
                      },
                      [_vm._v(" " + _vm._s(row.relevancy_role_name) + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "device_id",
              label: _vm.$t("recentLoginDevice"),
              width: "290"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(" " + _vm._s(row.device_id) + " ")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "register_time",
              label: _vm.$t("registerTime"),
              width: _vm.$utils.flexColumnWidth("2023-12-05 14:56:43", false)
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_login_time",
              label: _vm.$t("recentLoginTime"),
              "min-width": "210"
            }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "220", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.viewDetail(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("view")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      row.emperorStatus == 2
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.emperor(row, 1)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("banAccount")))]
                          )
                        : _vm._e(),
                      row.emperorStatus == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.unseal(row, 1)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("unban")))]
                          )
                        : _vm._e(),
                      row.emperorStatus != 3
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      row.speakingStatus == 2
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.emperor(row, 2)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("mute")))]
                          )
                        : _vm._e(),
                      row.speakingStatus == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.unseal(row, 2)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("unmute")))]
                          )
                        : _vm._e(),
                      row.speakingStatus != 3
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.sendEmail.open(row, "shot")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("sendMail")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total
        },
        on: {
          "current-change": function($event) {
            return _vm.searchClick($event, false)
          },
          "size-change": _vm.searchClickSizeChange
        }
      }),
      _vm.detailsData.length
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticClass: "marginB",
                  attrs: { data: _vm.detailsData, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "server_name",
                      label: _vm.$t("server"),
                      "min-width": "160"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_id",
                      label: _vm.$t("userId"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "role_name",
                      label: _vm.$t("roleName"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "role_id",
                      label: _vm.$t("roleId"),
                      "min-width": "170"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "level",
                      label: _vm.$t("level"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vip",
                      label: _vm.$t("vipLevel"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fighting",
                      label: _vm.$t("fightingPower"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "league_name",
                      label: _vm.$t("alliance"),
                      "min-width": "160",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "account_type",
                      label: _vm.$t("thirdPartyLoginType"),
                      width: "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recharge_amount",
                      label: _vm.$t("rechargeTotalAmount"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_time_amount",
                      label: _vm.$t("realTimeRechargeAmount"),
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remain_coin",
                      label: _vm.$t("coinCount"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remain_diamond",
                      label: _vm.$t("gemCount"),
                      "min-width": "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "relevancy_role_name",
                      label: _vm.$t("associatedAccount"),
                      "min-width": "160",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "text-ellipsis-1",
                                  staticStyle: { cursor: "pointer" }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(row.relevancy_role_name) + " "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1884808150
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "channel",
                      label: _vm.$t("channel"),
                      "min-width": "140"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(row.channel_name || row.channel) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4013907267
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_login_country",
                      label: _vm.$t("recentLoginRegion"),
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_login_time",
                      label: _vm.$t("recentLoginTime"),
                      "min-width": "210"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_logins",
                      label: _vm.$t("recentLoginDevice"),
                      width: "290"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("div", [
                                _vm._v(" " + _vm._s(row.device_id) + " ")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      344628089
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "register_country",
                      label: _vm.$t("language"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "register_time",
                      label: _vm.$t("registerTime"),
                      width: _vm.$utils.flexColumnWidth(
                        "2023-12-05 14:56:43",
                        false
                      )
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "country",
                      label: _vm.$t("country"),
                      "min-width": "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ip",
                      label: _vm.$t("ip"),
                      "min-width": "140"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        height: "100%"
                      },
                      attrs: { span: 4.5 }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.handleCheckedCitiesChange },
                          model: {
                            value: _vm.checkedCities,
                            callback: function($$v) {
                              _vm.checkedCities = $$v
                            },
                            expression: "checkedCities"
                          }
                        },
                        _vm._l(_vm.featureList, function(item, index) {
                          return _c(
                            "el-radio-button",
                            {
                              key: index,
                              attrs: { label: item.id, border: "" }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { width: "260px" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options": _vm.pickerOptionsRadius,
                          "value-format": "yyyy-MM-dd",
                          clearable: false,
                          type: "daterange",
                          align: "right",
                          "range-separator": _vm.$t("range"),
                          "start-placeholder": _vm.$t("startDate"),
                          "end-placeholder": _vm.$t("endDate")
                        },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("sourceId")
                            },
                            model: {
                              value: _vm.propertySearchData.resource_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.propertySearchData,
                                  "resource_id",
                                  $$v
                                )
                              },
                              expression: "propertySearchData.resource_id"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: _vm.$t("operationId")
                            },
                            model: {
                              value: _vm.propertySearchData.action,
                              callback: function($$v) {
                                _vm.$set(_vm.propertySearchData, "action", $$v)
                              },
                              expression: "propertySearchData.action"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2"
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "260px" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("changeType")
                              },
                              model: {
                                value: _vm.propertySearchData.kind,
                                callback: function($$v) {
                                  _vm.$set(_vm.propertySearchData, "kind", $$v)
                                },
                                expression: "propertySearchData.kind"
                              }
                            },
                            _vm._l(_vm.kindList, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "2" && _vm.property.length
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "100px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportdataDealoading
                              },
                              on: { click: _vm.exportproperty }
                            },
                            [_vm._v(_vm._s(_vm.$t("export")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "3" && _vm.searchCurrency.length
                    ? _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: _vm.$t("selectCurrencyType")
                              },
                              model: {
                                value: _vm.orderSearchData.currency_info,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.orderSearchData,
                                    "currency_info",
                                    $$v
                                  )
                                },
                                expression: "orderSearchData.currency_info"
                              }
                            },
                            _vm._l(_vm.searchCurrency, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.currency_name,
                                  value: item.currency
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities == "3" && _vm.orderData.length
                    ? _c(
                        "el-col",
                        { staticStyle: { width: "100px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.exportLoading
                              },
                              on: { click: _vm.exportdata }
                            },
                            [_vm._v(_vm._s(_vm.$t("exportAll")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkedCities != "5"
                    ? _c(
                        "el-col",
                        { attrs: { span: 1 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.reqLoadingTow
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleCheckedCitiesChange(
                                    _vm.checkedCities
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("query")))]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.checkedCities == "1"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "ksajaiqsasrfr",
                          attrs: { data: _vm.tableData, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_channel_reveal",
                              label: _vm.$t("adPlatform"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_placement_reveal",
                              label: _vm.$t("adPlacement"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "server_id",
                              label: _vm.$t("serverId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id",
                              label: _vm.$t("deviceNo"),
                              "show-overflow-tooltip": "",
                              width: "360"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "user_id",
                              label: _vm.$t("accountId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_id",
                              label: _vm.$t("roleId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: _vm.$t("roleName"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "desc_kind",
                              label: _vm.$t("itemType"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "desc_name",
                              label: _vm.$t("itemNameLabel"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "num",
                              label: _vm.$t("itemQuantity"),
                              "show-overflow-tooltip": ""
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.currentPage,
                          total: _vm.tableCopyTableList.length,
                          "page-size": _vm.pageSize
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange1,
                          "size-change": _vm.backSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "2"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "sdkjaoqiweq",
                          attrs: {
                            data: _vm.property,
                            border: "",
                            "max-height": "600px"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "user_id", label: _vm.$t("userId") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "role_id", label: _vm.$t("roleId") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id_str",
                              label: _vm.$t("deviceId"),
                              width: "360"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "ext", label: "ext" }
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("costLabel") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.resource.cost,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.item_name) +
                                              ":" +
                                              _vm._s(item.item_num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              4233693968
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("resourceOutputLabel") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.resource.output,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.item_name) +
                                              ":" +
                                              _vm._s(item.item_num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              2065771204
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("retention") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _vm._l(
                                      scope.row.resource.retain,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.item_name) +
                                              ":" +
                                              _vm._s(item.item_num) +
                                              " "
                                          )
                                        ])
                                      }
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              1385690622
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "action",
                              label: _vm.$t("operation")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "action_name",
                              label: _vm.$t("operationName")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "time",
                              label: _vm.$t("time"),
                              width: "200"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.propertySearchData.page,
                          total: _vm.propertyTotal,
                          page_size: _vm.propertySearchData.page_size
                        },
                        on: {
                          "current-change": _vm.getpropertyList,
                          "size-change": _vm.propertyHandleSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "3"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "sdjkahdsja",
                          attrs: { data: _vm.orderData, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_channel_reveal",
                              label: _vm.$t("adChannel"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ad_placement_reveal",
                              label: _vm.$t("adPlacement"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "country",
                              label: _vm.$t("country"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "order_id",
                              label: _vm.$t("rdOrderId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "pay_channel_order_id",
                              label: _vm.$t("channelOrderId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "user_id",
                              label: _vm.$t("userId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_id",
                              label: _vm.$t("roleId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "device_id",
                              label: _vm.$t("deviceId"),
                              "show-overflow-tooltip": "",
                              "min-width": "360"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "amount",
                              label: _vm.$t("payAmount"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$utils
                                              .conversion(row.amount)
                                              .toFixed(2)
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2165437223
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "product_id",
                              label: _vm.$t("rechargeProductId"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "product_name",
                              label: _vm.$t("rechargeProductName"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "timestamp",
                              label: _vm.$t("rechargeTime"),
                              "show-overflow-tooltip": "",
                              "min-width": "200"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "ip",
                              label: _vm.$t("ip"),
                              "show-overflow-tooltip": "",
                              "min-width": "150"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.orderSearchData.page,
                          total: _vm.orderTotal
                        },
                        on: {
                          "current-change": _vm.orderhandleCurrentChange,
                          "size-change": _vm.orderhandleCurrentChangeSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "4"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "asasikdjq",
                          attrs: { data: _vm.emailList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "server_id",
                              label: _vm.$t("serverId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "user_id",
                              label: _vm.$t("accountId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_id",
                              label: _vm.$t("roleId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "email_id",
                              label: _vm.$t("emailId"),
                              "show-overflow-tooltip": ""
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "receive_time",
                              label: _vm.$t("receiveTime"),
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$times.timestampToTime(
                                              row.receive_time,
                                              "YY-MM-DD HH"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3460515199
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "reward", label: _vm.$t("item") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      row.item_list !== "[]"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { color: "#409EFF" },
                                              on: {
                                                click: function($event) {
                                                  _vm.$refs.viewArticles.init(
                                                    JSON.parse(row.item_list),
                                                    "Articles"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("view")))]
                                          )
                                        : _c("div", [_vm._v("/")])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1966960944
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "request_data",
                              label: _vm.$t("contentDetails")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { color: "#409EFF" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$refs.richTextDetails.open(
                                                row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("view")))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2901457114
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "status",
                              label: _vm.$t("status"),
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      row.status == 0
                                        ? _c("div", [
                                            _vm._v(_vm._s(_vm.$t("unread")))
                                          ])
                                        : _vm._e(),
                                      row.status == 1
                                        ? _c("div", [
                                            _vm._v(_vm._s(_vm.$t("read")))
                                          ])
                                        : _vm._e(),
                                      row.status == 2
                                        ? _c("div", [
                                            _vm._v(_vm._s(_vm.$t("claimed")))
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2316308426
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == 5
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                height: "100%"
                              },
                              attrs: { span: 4.5 }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "mini" },
                                  on: { change: _vm.operationLogChange },
                                  model: {
                                    value: _vm.controlsSortIndex,
                                    callback: function($$v) {
                                      _vm.controlsSortIndex = $$v
                                    },
                                    expression: "controlsSortIndex"
                                  }
                                },
                                _vm._l(_vm.controlsSort, function(item, index) {
                                  return _c(
                                    "el-radio-button",
                                    {
                                      key: index,
                                      attrs: { label: index, border: "" }
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 1 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    height: "28px",
                                    "line-height": "12px",
                                    "margin-top": "2px"
                                  },
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    loading: _vm.reqLoadingTow
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.operationLogChange(
                                        _vm.controlsSortIndex
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("query")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.controlsSortIndex == 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.reqLoadingTow,
                                      expression: "reqLoadingTow"
                                    }
                                  ],
                                  key: "asaewqw1dc",
                                  attrs: {
                                    data: _vm.controlsSort[0].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "role_id",
                                      label: _vm.$t("playerId")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "pay_channel",
                                      label: _vm.$t("channelId")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "pay_id",
                                      label: _vm.$t("rechargeId")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "orderId",
                                      label: _vm.$t("orderNo")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "created_at",
                                      label: _vm.$t("replenishmentTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$times.timestampToTime(
                                                      row.created_at,
                                                      "YY-MM-DD HH"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2699609748
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "passwd_secret",
                                      label: _vm.$t("replenishmentType")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.supplement.filter(
                                                      function(item) {
                                                        return (
                                                          item.value ==
                                                          row.op_type
                                                        )
                                                      }
                                                    )[0].label
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2087678176
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "reward",
                                      label: _vm.$t("item")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              row.op_type !=
                                              "supplement_product"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        color: "#409EFF"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.viewCode(
                                                            row.reward
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("view"))
                                                      )
                                                    ]
                                                  )
                                                : _c("div", [_vm._v("/")])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      714091064
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "status",
                                      label: _vm.$t("replenishmentStatus")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    row.status == 1
                                                      ? _vm.$t("success")
                                                      : _vm.$t("failStatus")
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      878200230
                                    )
                                  })
                                ],
                                1
                              ),
                              _c("el-pagination", {
                                attrs: {
                                  layout: "total, sizes, prev, pager, next",
                                  "current-page": _vm.controlsSort[0].page,
                                  total: _vm.controlsSort[0].total
                                },
                                on: {
                                  "current-change": function($event) {
                                    return _vm.handleCurrentChange($event, 0)
                                  },
                                  "size-change": function($event) {
                                    return _vm.handleCurrentChangeSizeChange(
                                      $event,
                                      0
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.controlsSortIndex == 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.reqLoadingTow,
                                      expression: "reqLoadingTow"
                                    }
                                  ],
                                  key: "lsaisnhds",
                                  attrs: {
                                    data: _vm.controlsSort[1].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.admin_name || "/"
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      620019531
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire",
                                      label: _vm.$t("banTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.expire == 0
                                                      ? _vm.$t("permanentBan")
                                                      : _vm.$times.timestampToTime(
                                                          row.expire,
                                                          "YY-MM-DD HH"
                                                        )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2507039817
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "reason",
                                      label: _vm.$t("remark"),
                                      "show-overflow-tooltip": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-ellipsis-1"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        row.reason || "/"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2718878951
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "created_at",
                                      label: _vm.$t("operationTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.created_at
                                                      ? _vm.$times.formDate(
                                                          row.created_at,
                                                          "YY-MM-DD HH"
                                                        )
                                                      : "/"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3524612050
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.controlsSortIndex == 2
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.reqLoadingTow,
                                      expression: "reqLoadingTow"
                                    }
                                  ],
                                  key: "asaewqdfdfw",
                                  attrs: {
                                    data: _vm.controlsSort[2].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.admin_name || "/"
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      620019531
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire",
                                      label: _vm.$t("banTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.expire == 0
                                                      ? _vm.$t("permanentBan")
                                                      : _vm.$times.timestampToTime(
                                                          row.expire,
                                                          "YY-MM-DD HH"
                                                        )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2507039817
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "reason",
                                      label: _vm.$t("remark"),
                                      "show-overflow-tooltip": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-ellipsis-1"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        row.reason || "/"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2718878951
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "created_at",
                                      label: _vm.$t("operationTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.created_at
                                                      ? _vm.$times.formDate(
                                                          row.created_at,
                                                          "YY-MM-DD HH"
                                                        )
                                                      : "/"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3524612050
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.controlsSortIndex == 3
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.reqLoadingTow,
                                      expression: "reqLoadingTow"
                                    }
                                  ],
                                  key: "dsjhdfiuwks",
                                  attrs: {
                                    data: _vm.controlsSort[3].list,
                                    border: ""
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "admin_name",
                                      label: _vm.$t("operator")
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire",
                                      label: _vm.$t("operationTime")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$times.formDate(
                                                      row.created_at
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      724052954
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: _vm.$t("roleDetails") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "x-c" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "controlsBtn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$refs.recoveryviewArticles.init(
                                                            row.desc,
                                                            row.server_ids
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("view"))
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4213772610
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "request_data",
                                      label: _vm.$t("emailDetails")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "controlsBtn",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$refs.contentView.open(
                                                        row.request_data,
                                                        "recovery"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(_vm.$t("view")))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      326090529
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "expire",
                                      label: _vm.$t("status")
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.status == 2
                                                      ? _vm.$t("notRecycled")
                                                      : _vm.$t("recycled")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3103475657
                                    )
                                  })
                                ],
                                1
                              ),
                              _c("el-pagination", {
                                attrs: {
                                  layout: "total,sizes, prev, pager, next",
                                  "current-page": _vm.controlsSort[3].page,
                                  total: _vm.controlsSort[3].total
                                },
                                on: {
                                  "current-change": function($event) {
                                    return _vm.handleCurrentChange($event, 3)
                                  },
                                  "size-change": function($event) {
                                    return _vm.handleCurrentChangeSizeChange(
                                      $event,
                                      3
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkedCities == "6"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.reqLoadingTow,
                              expression: "reqLoadingTow"
                            }
                          ],
                          key: "wfefa",
                          attrs: { data: _vm.bagRetainList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "date", label: _vm.$t("date") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "game", label: _vm.$t("game") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "platform",
                              label: _vm.$t("platform")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "channel", label: _vm.$t("channel") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "pkg", label: _vm.$t("pkg") }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "role_id", label: _vm.$t("roleId") }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "server_name",
                              label: _vm.$t("serverName")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "role_name",
                              label: _vm.$t("playerName")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "item_name",
                              label: _vm.$t("itemNameLabel")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "item_id",
                              label: _vm.$t("itemIdLabel")
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "total_num",
                              label: _vm.$t("quantity")
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          layout: "total,sizes, prev, pager, next",
                          "current-page": _vm.bgCurrentPage,
                          total: _vm.bgTableCopyTableList.length,
                          "page-size": _vm.bgPageSize
                        },
                        on: {
                          "size-change": _vm.bgHandleSizeChange,
                          "current-change": _vm.bgHandleCurrentChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("addEmperor", {
        ref: "addEmperor",
        attrs: { prod: { is_prod: _vm.searchData.is_prod } },
        on: { change: _vm.emperorChange }
      }),
      _c("addEmail", {
        ref: "sendEmail",
        attrs: {
          serverList: _vm.serverLists,
          prod: { is_prod: _vm.searchData.is_prod }
        }
      }),
      _c("viewArticles", {
        ref: "viewArticles",
        attrs: { prod: { is_prod: _vm.searchData.is_prod } }
      }),
      _c("recoveryviewArticles", {
        ref: "recoveryviewArticles",
        attrs: { serverList: _vm.serverLists }
      }),
      _c("contentView", { ref: "contentView" }),
      _c("richTextDetails", { ref: "richTextDetails" }),
      _c("addExport", {
        ref: "addExport",
        attrs: {
          prod: {
            is_prod: _vm.searchData.is_prod,
            game_id: _vm.rawData.game_id
          },
          serverList: _vm.serverLists
        }
      }),
      _c("watchCodeDetails", { ref: "watchCodeDetails" }),
      _c(
        "el-drawer",
        {
          attrs: { title: _vm.$t("details"), visible: _vm.isCode },
          on: {
            "update:visible": function($event) {
              _vm.isCode = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 20px 0", position: "relative" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.codeLists, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "expire",
                      label: _vm.$t("time"),
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$times.timestampToTime(row.expire)) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "item_id", label: _vm.$t("item") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.articleList.findIndex(function(item) {
                                    return item.id == row.item_id
                                  }) > -1
                                    ? _vm.articleList.find(function(item) {
                                        return item.id == row.item_id
                                      }).kind
                                    : row.item_id
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: _vm.$t("quantity") }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }